<template>
    <KillerSplashPlayer
        :player="player"
        :color="color"
        :title="$t('play.your_turn')"
        :hint="hint"
        :is-killer="isKiller"
        :hud="hud"
    />
</template>

<script>
import KillerSplashPlayer from './KillerSplashPlayer.vue'
import hud from '@/assets/images/games/killer/splash/hud-turn.svg'
import { MAX_STATUS_POINTS } from '../killerConstants.js'

export default {
    name: 'KillerSplashTurn',
    components: { KillerSplashPlayer },
    props: {
        player: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        targetNumber: {
            type: Number,
            default: null,
        },
        isKiller: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hud,
        }
    },
    computed: {
        hint() {
            if (this.isKiller) return this.$t('killer.killer_instructions')
            return this.$t('killer.become_killer_hint', {
                points: MAX_STATUS_POINTS,
                number: this.targetNumber,
            })
        },
    },
}
</script>
